// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1wGtJ","label":"Completed_label__Vl3Lf"};